import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCardTypeList } from '@/api/order';
export default {
  name: 'standardCardDiscount',
  props: {
    card_bin_group_id: {
      type: Number | String,
      default: function _default() {
        return '';
      }
    },
    card_bin_id: {
      type: Number | String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function mounted() {
    this.getCardList();
  },
  methods: {
    getCardList: function getCardList() {
      var _this = this;
      var params = {
        group_id: this.card_bin_group_id,
        card_bin_id: this.card_bin_id
      };
      getCardTypeList(params).then(function (res) {
        _this.list = res.data;
      });
    }
  }
};